export const skillsData = [
    {
      name: "Python",
      rating: 9,
      location: "python.png"
    },
    {
      name: "C - Language",
      rating: 7,
      location: "letter-c.png"
    },
    {
      name: "HTML",
      rating: 9,
      location: "html-5.png"
    },
    {
      name: "CSS",
      rating: 8,
      location: "css-3.png"
    },
    {
      name: "JS",
      rating: 8,
      location: "js.png"
    },
    {
      name: "React",
      rating: 7,
      location: "react-img.png"
    }
  ];
  